import React, { useEffect, useState, useContext, useRef } from "react";
import appConst from "../Utilities/appConst.json";
import CouponInput from "../Components/CouponInput";
import { footerActions } from "../store/footerSlice";
import { alertActions } from "../store/alertSlice";
import { basketActions } from "../store/basket";
import { refreshCouponsBeforePayment } from "../store/couponsSlice";
import {
  creditGuardActions,
  postCreditGuardScreen,
} from "../store/creditGuardSlice";
import { useDispatch, useSelector } from "react-redux";
import { LanguageContext } from "../context/language/LanguageContext";
import SummaryShipping from "../Components/SummaryShipping";
import PolicyApproval from "../Components/PolicyApproval";
import Coupons from "../Components/Coupons";
import { modeActions } from "../store/modeSlice";
import SelectedCoupons from "../Components/SelectedCoupons";
import PageLayout from "../Components/PageLayout";
import "../styles/summary.css";
import "../styles/basket.css";
import { disableButton, enableButton } from "../Utilities/styleUtil";
import SummaryBasketItemsAccordion from "../Components/SummaryBasketItemsAccordion";
import { useHistory, useLocation } from "react-router-dom";
import { loaderActions } from "../store/loaderSlice";
import useBrazeScreenView from "../hooks/useBrazeScreenView";

const Summary = () => {
  useBrazeScreenView();
  const languageContext = useContext(LanguageContext);
  const dispatch = useDispatch();
  const policyApprovalRef = useRef(null);
  const history = useHistory();
  const location = useLocation();

  const shippingMethod = useSelector((state) => state.coupons.shippingMethod);
  const shippingPrice = useSelector((state) => state.coupons.shippingPrice);
  const basket = useSelector((state) => state.basket.basket);
  const combinations = useSelector((state) => state.coupons.combinations);
  const totalCouponsDiscounts = useSelector(
    (state) => state.coupons.totalCouponsDiscounts
  );
  const footer = useSelector((state) => state.footer.summary);
  const shouldScrollTo = useSelector((state) => state.alert.shouldScrollTo);
  const isDeferred = useSelector((state) => state.coupons.isDeferred);
  const amountDue = useSelector((state) => state.coupons.amountDue);
  const messages = useSelector((state) => state.coupons.messages);
  const selectedCombination = useSelector(
    (state) => state.coupons.selectedCombination
  );
  const collectionBucketCoupons = useSelector(
    (state) => state.coupons.collectionBucketCoupons
  );
  const creditGuard = useSelector((state) => state.creditGuard);
  const isGetCouponsFinished = useSelector(
    (state) => state.coupons.isGetCouponsFinished
  );
  const licenseData = useSelector((state) => state.license.licenseData);

  const [isApproved, setIsAprroved] = useState(false);
  const [isInvoiceMatrix, setIsInvoiceMatrix] = useState(false);
  const [prevSelectedCombination, setPrevSelectedCombination] =
    useState(selectedCombination);

  useEffect(() => {
    dispatch(modeActions.setValueGA4({ value: appConst.insert_coupon }));
  }, [combinations]);

  useEffect(() => {
    dispatch(footerActions.setIsShow(true));
    dispatch(
      footerActions.setBtnText(
        isDeferred
          ? languageContext.getTranslation(appConst.TO_ELEVNTH_PAGE)
          : languageContext.getTranslation(appConst.TO_NINTH_PAGE)
      )
    );
    dispatch(
      footerActions.setBeforeContinue(() => {
        dispatch(
          alertActions.createAlert({
            title: languageContext.getTranslation(appConst.ALERT_SUMMARY_TITLE),
            message: languageContext.getTranslation(
              appConst.ALERT_SUMMARY_MESSAGE
            ),
            isDialog: false,
            hasScrollTo: true,
          })
        );
      })
    );
    dispatch(footerActions.setNextPage(""));
    dispatch(alertActions.closeAlert());
    disableButton(dispatch);
    showCouponsMessages();

    // componentWillUnmount
    return () => {
      dispatch(
        footerActions.setFooterFromSelectedCoupons({
          tempShippingDiscount: null,
          tempAdditionalDiscount: null,
          tempTotal: null,
          tempShipping: null,
        })
      );
    };
  }, []);

  useEffect(() => {
    dispatch(
      footerActions.setBtnText(
        isDeferred
          ? languageContext.getTranslation(appConst.TO_ELEVNTH_PAGE)
          : languageContext.getTranslation(appConst.TO_NINTH_PAGE)
      )
    );
  }, [isDeferred]);

  useEffect(() => {
    dispatch(
      footerActions.setBtnText(
        amountDue === 0
          ? languageContext.getTranslation(appConst.TO_ELEVNTH_PAGE)
          : languageContext.getTranslation(appConst.TO_NINTH_PAGE)
      )
    );
  }, [amountDue]);

  useEffect(() => {
    if (shouldScrollTo) {
      policyApprovalRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [shouldScrollTo]);

  useEffect(() => {
    if (
      selectedCombination != prevSelectedCombination ||
      (collectionBucketCoupons && collectionBucketCoupons.length)
    ) {
      const shippingDiscount =
        selectedCombination.delivery_base_price -
        selectedCombination.delivery_final_price;
      const totalDiscounts = totalCouponsDiscounts;
      const totalPrice = selectedCombination.total_final_price;
      const points =
        basket && basket.payments ? basket.payments.total_payment : 0;

      dispatch(
        footerActions.setFooterFromSelectedCoupons({
          tempShippingDiscount: shippingDiscount,
          tempAdditionalDiscount: totalDiscounts + points,
          tempTotal: totalPrice - points,
          tempShipping: selectedCombination.delivery_base_price,
          priceList: selectedCombination.total_items_base_price,
        })
      );

      dispatch(basketActions.setBasketCouponsCombinations(combinations));
      setPrevSelectedCombination(selectedCombination);
    }
  }, [selectedCombination]);

  useEffect(() => {
    const shippingDiscount =
      selectedCombination.delivery_base_price -
      selectedCombination.delivery_final_price;
    const totalDiscounts = totalCouponsDiscounts;
    const totalPrice = selectedCombination.total_final_price;
    const points = basket?.payments?.total_payment || 0;

    dispatch(
      footerActions.setFooterFromSelectedCoupons({
        tempShippingDiscount: shippingDiscount,
        tempAdditionalDiscount: totalDiscounts + points,
        tempTotal: totalPrice - points,
        tempShipping: selectedCombination.delivery_base_price,
        priceList: selectedCombination.total_items_base_price,
      })
    );
  }, [totalCouponsDiscounts]);

  useEffect(() => {
    if (isApproved) {
      dispatch(footerActions.setNextPage(appConst.NINTH_PAGE));
      enableButton(dispatch);
      dispatch(
        footerActions.setBeforeContinue(async () => {
          const canPay = await dispatch(refreshCouponsBeforePayment());
          if (!canPay) {
            dispatch(
              alertActions.createAlert({
                title: languageContext.getTranslation(
                  appConst.ALERT_PRICE_UPDATED_TITLE
                ),
                message: languageContext.getTranslation(
                  appConst.ALERT_PRICE_UPDATED_MESSAGE
                ),
                isDialog: false,
              })
            );
            return false;
          }

          dispatch(
            footerActions.setFooterFromSummary({
              total: parseFloat(footer.tempTotal || footer.total).toFixed(2),
            })
          );
          dispatch(
            postCreditGuardScreen(basket, isInvoiceMatrix, history, location)
          );
        })
      );
      dispatch(basketActions.setIFrameURL(""));
    } else {
      dispatch(footerActions.setNextPage(""));
      disableButton(dispatch);
      dispatch(
        footerActions.setBeforeContinue(() => {
          dispatch(
            alertActions.createAlert({
              title: languageContext.getTranslation(
                appConst.ALERT_SUMMARY_TITLE
              ),
              message: languageContext.getTranslation(
                appConst.ALERT_SUMMARY_MESSAGE
              ),
              isDialog: false,
              hasScrollTo: true,
            })
          );
        })
      );
    }
  }, [isApproved, basket]);

  useEffect(() => {
    if (creditGuard.isError) {
      switch (creditGuard.errorCode) {
        case appConst.CREDIT_GARD_MANY_TIME_FAILED_ID:
          dispatch(
            alertActions.createAlert({
              title: languageContext.getTranslation(
                appConst.ALERT_CREDIT_GARD_MANY_TIME_FAILED_ID_TITLE
              ),
              message: languageContext.getTranslation(
                appConst.ALERT_CREDIT_GARD_MANY_TIME_FAILED_ID_MESSAGE
              ),
              isDialog: false,
            })
          );
          break;
        default: {
          dispatch(
            alertActions.createAlert({
              title: languageContext.getTranslation(
                appConst.ALERT_CREDIT_GUARD_TITLE
              ),
              message: languageContext.getTranslation(
                appConst.ALERT_CREDIT_GUARD_MESSAGE
              ),
              isDialog: false,
            })
          );
        }
      }

      dispatch(
        creditGuardActions.setError({
          isError: false,
          errorCode: -1,
        })
      );
    }
  }, [creditGuard.isError]);

  const showCouponsMessages = () => {
    if (messages) {
      const messageTypeNotApplied = messages.filter(
        (message) =>
          message.message_type ===
          appConst.INPUT_COUPON_MESSAGE_TYPE_NOT_APPLIED
      );

      if (messageTypeNotApplied && messageTypeNotApplied.length > 0) {
        dispatch(
          alertActions.createAlert({
            title: messageTypeNotApplied[0]
              ? messageTypeNotApplied[0].title
              : "",
            message: messageTypeNotApplied[0]
              ? messageTypeNotApplied[0].message
              : "",
            isDialog: true,
            yesButtonText: appConst.COUPON_NOT_APPLIED_YES_BUTTON_TEXT,
            noButtonText: appConst.COUPON_NOT_APPLIED_NO_BUTTON_TEXT,
            hasNext: true,
            nextDialogTitle: appConst.COUPON_INFO_TITLE,
            nextDialogMessage: messageTypeNotApplied[0]
              ? messageTypeNotApplied[0].terms_and_conditions
              : "",
            nextDialogOkButtonText: appConst.COUPON_NOT_APPLIED_NO_BUTTON_TEXT,
          })
        );
      }
    }
  };

  useEffect(() => {
    if (isGetCouponsFinished) {
      dispatch(loaderActions.loaderHide());
    } else {
      dispatch(loaderActions.loaderShow());
    }
  }, [isGetCouponsFinished]);

  const handleOnCheckApprove = (isApproved) => {
    setIsAprroved(isApproved);
    dispatch(modeActions.setValueGA4({ value: appConst.order_now_button }));
  };

  return (
    <PageLayout className="summary_page" data-testid="summary-page">
      <div data-testid="summary-coupon-input-section">
        <CouponInput isApproved={isApproved} isInvoiceMatrix={isInvoiceMatrix} />
      </div>
      <div data-testid="summary-coupons-section">
        <Coupons />
      </div>
      <div data-testid="summary-basket-items-section">
        <SummaryBasketItemsAccordion />
      </div>
      <div data-testid="summary-shipping-section">
        <SummaryShipping
          shippingMethod={shippingMethod}
          shippingPrice={shippingPrice}
        />
      </div>
      <div data-testid="summary-selected-coupons-section">
        <SelectedCoupons />
      </div>
      <div ref={policyApprovalRef} data-testid="summary-policy-approval-section">
        <PolicyApproval
          licenseData={licenseData}
          setIsApproved={(isApproved) =>
            handleOnCheckApprove(isApproved, isInvoiceMatrix)
          }
        />
      </div>
    </PageLayout>
  );
};
export default Summary;
